<template>
  <span class="preview">
    <i
      v-if="prependicon"
      class="preview-icon icon-prepend fa"
      :class="prependicon.startsWith('fa-') ? prependicon : ''"
    >
      {{ prependicon.startsWith('fa-') ? '' : prependicon }}
    </i>

    <span
      :id="model.$form.generateId ? model.$pathId : undefined"
      class="preview-text text-middle"
      :class="{
        'text-bold': bold,
        'appendicon-text-right': appendicon,
        'prependicon-text-left': prependicon,
        'both-side': appendicon && prependicon
      }"
      :data-path="model.$form.testPath ? model.$path : undefined"
    >
      <slot>{{ value }}</slot>
    </span>

    <i v-if="appendicon" class="preview-icon icon-append fa" :class="appendicon.startsWith('fa-') ? appendicon : ''">{{
      appendicon.startsWith('fa-') ? '' : appendicon
    }}</i>

    <br v-if="showError && model.$error" />

    <w-error v-if="showError" :model="model" class="error-msg" />
  </span>
</template>

<script>
import WError from './error.vue';
export default {
  name: 'WPreview',
  components: { WError },
  props: {
    model: Object,
    bold: Boolean,
    values: Array,
    valueKey: { type: String, default: 'value' },
    valueText: { type: String, default: 'text' },
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    },
    default: {
      type: [String, Number],
      default: ''
    },
    showError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    value: {
      get() {
        if (!this.model) {
          return '';
        }
        if (!this.values) {
          if (this.model.$value.length === 0 && this.default.length > 0) {
            return this.default;
          }
          return this.model.$value;
        }

        const key = this.valueKey || 'value';
        const textKey = this.valueText || 'text';
        const value = this.values.find(item => {
          return item[key] === this.model.$value;
        });
        if (value === undefined) {
          return '';
        }
        return value[textKey];
      }
    }
  }
};
</script>
<style scoped>
span.preview,
span.preview div.error-msg {
  display: inline-block;
}
span.preview {
  vertical-align: top;
}
td > span.preview div.error-msg {
  display: block;
}
td > span.preview {
  min-height: 32px;
  display: block;
}
.preview-icon {
  position: relative !important;
}
td span.preview-text {
  display: inline-block;
  position: relative !important;
  top: 4px;
}
.appendicon-text-right {
  padding-right: 10px;
}
.prependicon-text-left {
  padding-left: 12px;
}
.both-side {
  width: Calc(100% - (2 * 26px) - 12px - 10px);
}
</style>
